import React, {Component} from "react";
import InputText from "../components/InputText";
import Alert from "../components/Alert";
import logoConquerBusiness from "../assets/images/logoConquerBusiness.svg";
import Device from "../utils/Device"

import {inject, observer} from "mobx-react";

import "../assets/stylesheets/Login.scss";


@inject('AuthStore', 'Navigator', 'ConfigStore', 'SchoolStore', 'ProductStore')
@observer
export default class Login extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            index: 0,
            username: "",
            password: "",
            showAlert: false,
            message: "",
            type: "password", // controls the type of password input
            bottom: "24%", // controls the bottom of the show password div
        };

        this.submit = this.submit.bind(this);
        this.handleButtonLoginClick = this.handleButtonLoginClick.bind(this);
    }

    componentWillMount(){
        this.props.SchoolStore.students = [];
        this.props.SchoolStore.studentsEngagement = [];
        this.props.SchoolStore.schoolSelected   = null;
        this.props.SchoolStore.classSelected   = null;
        this.props.SchoolStore.lessonSelected  = null;
        this.props.SchoolStore.isSearch = false;
    }

    handleButtonLoginClick(e) {
        this.submit(e);
    }

    handleShowPassword(e){
        if(e.target.className === "icon-password-white"){
            e.target.className = "icon-password-white-close";
            this.setState({type: "text"});
        }else{
            e.target.className = "icon-password-white";
            this.setState({type: "password"});
        }
    }

    /**
     * Efetua o Login
     * @param e
     * @return {boolean}
     */
    submit = (e) => {
        e.preventDefault();

        if ((this.state.username.trim().length <= 0
            || this.state.password.trim().length <= 0)) {
            this.props.AuthStore.isLoading = false;
            this.setState({message: "Nome de usuário e/ou senha inválidos", loading: false, bottom: "29%"});
            return false;
        }

        let params = {
            'username': this.state.username.trim().toLowerCase(),
            'password': this.state.password.trim()
        };

        this.props.AuthStore.doLogin(params)
            .then(
                json => {
                    if (this.props.AuthStore.isLogged) {
                        const userUnit = this.props.AuthStore.units[0];
                        this.props.ProductStore.checkIfShowProductSelector(userUnit);
                        this.props.ConfigStore.animationType = 'left';
                        this.props.Navigator.push('/');
                    } else {
                        this.props.AuthStore.isLoading = false;
                        this.setState({message: "Nome de usuário e/ou senha inválidos", loading: false, bottom: "29%"});
                    }
                }
            ).catch(e => this.setState({message: "Nome de usuário e/ou senha inválidos", loading: false, bottom: "29%"}));
    };

    handleFieldChange = (e) => {
        this.setState({[e.target.name]: e.target.value});
    };

    handleSendSupportEmail(e) {
        e.preventDefault();
        this.setState({showAlert: true, message:"E-mail has sended to support.", loading: false, bottom: "35%"});
    }

    handleCloseAlert(e) {
        this.setState({showAlert: false});
    }

    invalidateErrorMessage() {
        this.setState({message:'', bottom: "24%"});
    }

    handleOpenEmail(e) {
        console.log("calling action requestOpenEmailProvider from native");
        Device.requestOpenEmailProvider();
    }


    render() {
        const {isLoading, user} = this.props.AuthStore;
        const loading = isLoading ? "loading" : "";

        return (
            <div className='Login Page'>

                <div className='form-login'>
                    <img src={logoConquerBusiness} role="presentation"/>

                    <form onSubmit={this.submit} className={this.state.loading} ref={ref => this.form = ref}>
                        <InputText name="username"
                                   labelText="Usuario"
                                   value={this.state.username}
                                   onChange={this.handleFieldChange.bind(this)}
                                   placeholder="CPF"
                                   mask="999.999.999-99"
                                   type="text"
                                   disabled={isLoading}
                                   onFocus={this.invalidateErrorMessage.bind(this)}/>
                        <InputText type={this.state.type}
                                   name="password"
                                   labelText="Password"
                                   value={this.state.password}
                                   onChange={this.handleFieldChange.bind(this)}
                                   placeholder="Senha"
                                   disabled={isLoading}
                                   onFocus={this.invalidateErrorMessage.bind(this)}/>

                        <div className="icon-password-white"
                             style={{bottom: this.state.bottom}}
                             onClick={this.handleShowPassword.bind(this)}>
                        </div>

                        <div className={"error-message" + (this.state.message.length > 0 ? " show" : "")}>{this.state.message}</div>

                        <div className="btn-container">
                            <button className={"btn " + loading} onClick={this.handleButtonLoginClick} >
                                {!loading && 'LOGIN'}</button>
                        </div>

                        {/*<a href=""*/}
                           {/*onClick={this.handleOpenEmail.bind(this)}>or click here, to get support</a>*/}
                    </form>
                </div>

                <Alert show={this.state.showAlert}
                       message={this.state.message}
                       onClick={this.handleCloseAlert.bind(this)}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js